import type {
  GetBillingCyclesResponse,
  ReadinessSkips,
} from '../../services/api/types.gen';

/** What a check the cycle's insurance skips reads as. */
export const NOT_REQUIRED_MESSAGE = 'Not required for this insurance';

/** The readiness checks a row's insurance skips, each defaulting to off. */
export function readinessSkipsOf(
  entry: Pick<GetBillingCyclesResponse, 'readiness_skips'>
): Required<ReadinessSkips> {
  const skips = entry.readiness_skips;
  return {
    visits: skips?.visits ?? false,
    orders: skips?.orders ?? false,
    payment_oasis: skips?.payment_oasis ?? false,
    hipps: skips?.hipps ?? false,
    authorization: skips?.authorization ?? false,
  };
}
